/**
 * @generated SignedSource<<8215703f1ab85811e4e5821603830932>>
 * @relayHash 224e8ab30460c1a736ebe973745d3db2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9684d768c156f42ad8980c04cd1fa8ab2813822ae9c4e8a79767a4f23f2b3dab

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoard_JiraBoardQuery } from './JiraBoard_JiraBoardQuery.graphql';

import isAssignAgentsInlineM2TechnicalEnabled_provider from '@jira/board__relay-providers/src/AssignAgentsInlineM2TechnicalRelayprovider';
import includeAgentRules_provider from '@jira/board__relay-providers/src/AssignMultiAgentsBoardM2DndRelayProvider';
import isAutoManagedSprintsEnabled_provider from '@jira/board__relay-providers/src/AutoManagedSprintsForHarmonisedBoard';
import withBoardM3_provider from '@jira/board__relay-providers/src/BoardHarmonisationMilestone3';
import boardInlineAssignAgent_provider from '@jira/board__relay-providers/src/BoardInlineAssignAgent';
import jisDevSummaryField_provider from '@jira/board__relay-providers/src/BoardJISDevSummaryField';
import includeGups_provider from '@jira/board__relay-providers/src/JfindMatureExampleProject';
import withSwimlanesChangeboarding_provider from '@jira/board__relay-providers/src/SwimlanesChangeboarding';
import withTmpHarmonisationOnboarding_provider from '@jira/board__relay-providers/src/TmpHarmonisationOnboarding';

const node: PreloadableConcreteRequest<JiraBoard_JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9684d768c156f42ad8980c04cd1fa8ab2813822ae9c4e8a79767a4f23f2b3dab",
    "metadata": {},
    "name": "JiraBoard_JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraboard__relayproviderssrcJfindMatureExampleProjecttsx": includeGups_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": withSwimlanesChangeboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": withTmpHarmonisationOnboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": isAutoManagedSprintsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHarmonisationMilestone3tsx": withBoardM3_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignAgentsInlineM2TechnicalRelayprovidertsx": isAssignAgentsInlineM2TechnicalEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignMultiAgentsBoardM2DndRelayProvidertsx": includeAgentRules_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardJISDevSummaryFieldtsx": jisDevSummaryField_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": boardInlineAssignAgent_provider
    }
  }
};

export default node;
